import { lazy } from 'react';

export const HomeRoutes = {
  Home: lazy(() => import('@/modules/Home/pages/Home').then(({ Home }) => ({ default: Home }))),
};
